import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Modal } from './Modal.jsx';

export function ImagePreviewModal({ isOpen, onClose, src, alt = 'Full size image' }) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      showCloseButton={true}
    >
      {src ? (
        <img
          className="w-full object-contain max-h-[70vh]"
          src={src}
          alt={alt}
        />
      ) : null}
    </Modal>
  );
}

ImagePreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  src: PropTypes.string,
  alt: PropTypes.string,
};
